import { getDiscountCodeFromSearchParams, getSearchParams } from '@sky-distribution/gp-onboarding-shared-utils';
import { AppStateMachineContext } from '../types';

export const saveDiscountCodeFromSearchParams = (context: AppStateMachineContext): AppStateMachineContext => {
  const params = Array.from(getSearchParams());
  const discountCode = getDiscountCodeFromSearchParams(params);

  if (!discountCode || !context.discountProductCode) {
    return context;
  }

  if (context.submission?.discount) {
    return context;
  }

  return {
    ...context,
    submission: {
      ...context.submission,
      discount: {
        product: context.discountProductCode,
        code: discountCode,
      },
    },
    digitalSubmission: {
      ...context.digitalSubmission,
      discount: {
        product: context.discountProductCode,
        code: discountCode,
      },
    },
  };
};
